import React from 'react'

// `split_pct` IS the seller's share, rendered raw (spec D16 — never derive
// 100 − split; the HubSpot-era field of the same name meant our commission).
// NULL terms on a stamped item mean a legacy pre-terms consignment — say so
// rather than guessing a number. `title` overrides the tooltip where the
// split isn't the point (e.g. the pricing pages, where the item is on its
// markdown curve rather than awaiting a payout).
export function ConsignmentBadge({ splitPct, title }) {
  const resolvedTitle = title != null
    ? title
    : splitPct != null
      ? `Consignment — seller receives ${splitPct}%`
      : 'Consignment — terms unknown, check the quote'
  return <span className="badge badge-purple" title={resolvedTitle}>Consignment</span>
}

export default ConsignmentBadge
